import { ScrewGroup } from '../../../../object-view/objects/screw';


export default [
  {
    id: 'standart_single',
    icon: 'icon_generalcalculation-square1',
    config: {
      formation: ScrewGroup.formation.FILLED_SQUARE,
      count: {
        n: 1,
        m: 1,
        ignorePositions: []
      }
    },
    tooltip:"TT104"
  },
  {
    id: 'standart_linear',
    icon: 'icon_generalcalculation-square2',
    config: {
      formation: ScrewGroup.formation.FILLED_SQUARE,
      count: {
        n: 2,
        m: 1,
        ignorePositions: []
      }
    },
    tooltip:"TT104"
  },
  {
    id: 'standart_triangular',
    icon: 'icon_editor-triangular',
    config: {
      formation: ScrewGroup.formation.TRIANGLE,
      count: {
        n: 2,
        ignorePositions: []
      }
    },
    tooltip:"TT104"
  },
  {
    id: 'standart_edgeMatrix',
    icon: 'icon_generalcalculation-square4',
    config: {
      formation: ScrewGroup.formation.FILLED_SQUARE,
      count: {
        n: 2,
        m: 2,
        ignorePositions: []
      }
    },
    tooltip:"TT104"
  }
];



// WEBPACK FOOTER //
// ./src/components/Editor/Anchors/Buttons/standart.js